<template>
  <div class="details-view">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          class="section grid-fill"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider ref="cargoButtonGroupSlider">
                <div v-show="action==='look'" :class="'btn-group-look' + (canOperateJob ? '' : ' cannot-operate-job')">
                  <el-button no="back" type="primary" class="can-operate" @click="backEventFlag=true">{{ $t('common.btn.back') }}</el-button>
                  <el-button v-if="canEditByPermission" no="edit" :disabled="!(job && Number(job.jobState) === 0 && !JobUtils.isBlockJob(job))" type="success" @click="editEventFlag=true">{{ $t('common.btn.edit') }}</el-button>
                </div>
                <div v-show="isNew||action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button no="save" type="success" :disabled="context.loading" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="cancel" type="success" :disabled="context.loading" @click="cancelEdit">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button
                    no="SaveTheDefaultValues"
                    type="primary"
                    @click="saveDefaultVal"
                  >{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                  <span v-show="action==='edit'" style="font-size:12px;color:unset;">{{ stateInfo.customer }}</span>
                  <span v-show="action==='edit'" style="font-size:12px;color:unset;" v-html="commonInfo.jobTitle" />
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'" style="white-space:nowrap;display:flex;">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <el-tooltip
                  effect="dark"
                  :content="action==='edit' ? '' : $t('SeaExport.Tip1')"
                  placement="bottom-start"
                  :offset="sopTooltipOffset"
                  :visible-arrow="false"
                >
                  <div
                    style="width: 100%;cursor: pointer"
                    @mousemove="resetSopTooltip"
                    @dblclick="onBtnListDoubleClicked"
                  >
                    <span no="SopState" style="font-size:14px;color:red;padding:5px 0">{{ stateInfo.jobState }}</span>
                    <span
                      v-show="isCommittedAllowAddCost"
                      style="font-size:14px;color:red;padding:5px 0 5px 9px"
                    >{{ stateInfo.jobChangeState }}</span>
                    <span v-if="job.payableChargeLockedStatus === 1" style="font-size:14px;color:red;padding:5px 0 5px 9px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
                    <span style="font-size:12px;padding: 5px 9px;color:unset;">{{ stateInfo.jobNo }}</span>
                    <span
                      v-show="aiHeaderShowTitleMblMid"
                      style="font-size:12px;padding: 5px 9px;color:unset;"
                    >{{ stateInfo.titleMblMid }}</span>
                    <span
                      style="font-size:12px;color:unset;"
                    >{{ stateInfo.customer }}</span>
                    <span style="font-size:12px;color:unset;" v-html="commonInfo.jobTitle" />
                    <span v-if="commonInfo.provisionLock && commonInfo.provisionLock.etdLocked" style="font-size:14px;color:red;margin-left:10px;">计提已校准</span>
                  </div>
                </el-tooltip>
                <el-tooltip v-if="currentRow.zyCreditWarning" effect="dark" :content="currentRow.zyCreditWarning" placement="bottom-start" :visible-arrow="false">
                  <div class="right-tip" style="cursor:pointer;font-size:12px;color:orange;width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                    <span>{{ currentRow.zyCreditWarning }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!masterFlag"
                :key="1"
                :lazy="true"
                name="tabBookingFCL"
                :label="$t('SeaExport.AirOperation')"
              >
                <tab-booking-FCLUICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="tabBookingFCL"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @resetTab="resetTab"
                  @resetData="resetData"
                  @updateJob="updateJob"
                />
                <tab-booking-fcl
                  v-else
                  ref="tabBookingFCL"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  @resetTab="resetTab"
                  @resetData="resetData"
                  @updateJob="updateJob"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag"
                :key="2"
                :lazy="true"
                name="tabBookingMaster"
                :label="$t('SeaExport.MblInfo')"
              >
                <tab-booking-master-UICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  view-source="bookingWorkspace"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @addLcl="addBatchLcl"
                  @selectJob="transferTargetRow"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @resetTab="resetTab"
                  @resetData="resetData"
                />
                <tab-booking-master
                  v-else
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  view-source="bookingWorkspace"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @addLcl="addBatchLcl"
                  @selectJob="transferTargetRow"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @resetTab="resetTab"
                  @resetData="resetData"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearance"
                :lazy="true"
                name="tabUsCustomsClearance"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance ref="tabUsCustomsClearance" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearanceMaster"
                :lazy="true"
                name="tabUsCustomsClearanceMaster"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance-master ref="tabUsCustomsClearanceMaster" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                :key="3"
                :lazy="true"
                name="tabTradeDetail"
                :label="$t('SeaExport.TradeDetail')"
              >
                <tab-trade-detail ref="tabTradeDetail" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.uuid&&paramsOfTab.itmService"
                :key="4"
                :lazy="true"
                name="tabTradeCommission"
                :label="$t('SeaExport.TradeCommission')"
              >
                <tab-trade-commission ref="tabTradeCommission" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="(masterFlag || paramsOfTab.operateType === 1 || paramsOfTab.operateType === 2) && paramsOfTab.uuid"
                :key="15"
                :lazy="true"
                name="tabMAWB"
                :label="$t('SeaExport.MBLInfo')"
              >
                <tab-mawb ref="tabMAWB" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.operateType !== 1 && !masterFlag && paramsOfTab.uuid"
                :key="5"
                :lazy="true"
                name="tabHbl"
                :label="$t('SeaExport.HblInfo')"
              >
                <tab-hbl ref="tabHbl" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="$checkPermission(['tab_Charge_chargeView'])"
                :key="6"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" :location="location" view-source="AiBooking" :provision-lock="commonInfo.provisionLock" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.uuid && $checkPermission(['tab_ChargeConfirm_chargeConfirmView'])"
                :key="7"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane
                v-if="paramsOfTab.uuid && $checkPermission(['tab_billTab_billTabView'])"
                :key="8"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" :location="location" view-source="AiBooking" />
              </el-tab-pane>
              <el-tab-pane
                v-if="Boolean(paramsOfTab.uuid)"
                :key="9"
                :lazy="true"
                name="tabAdvanceCharge"
                :label="$t('SeaExport.AdvanceChargeInfo')"
              >
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.uuid && paramsOfTab.customs"
                :key="10"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclaration')"
              >
                <tab-customs-info ref="tabCustomsInfo" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
              </el-tab-pane>
              <!-- 保险 -->
              <el-tab-pane
                v-if="paramsOfTab.insure"
                :lazy="true"
                name="tabInsure"
                :label="$t('SeaExport.InsureInfo')"
              >
                <tab-insure ref="tabInsure" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.uuid"
                :key="11"
                :lazy="true"
                name="tabFile"
                :label="$t('SeaExport.DocumentCirculation')"
              >
                <tab-file ref="tabFile" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.uuid"
                :key="12"
                :lazy="true"
                name="tabLocalService"
                :label="$t('SeaExport.LocalService')"
              >
                <tab-local-service ref="tabLocalService" :context="context" :action="action" :cooperate-edit-warehouse="cooperateEditWarehouse" :cooperate-edit-trucking="cooperateEditTrucking" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!isNew && paramsOfTab.uuid && !masterFlag && $checkPermission(['tab_AIBooking_portalState'])"
                :key="13"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :sop-template-config="sopTemplateConfig" />
              </el-tab-pane>
              <el-tab-pane
                v-if="Boolean(paramsOfTab.uuid)"
                :key="14"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :cooperate-edit="cooperateEditOther" :can-operate-job="canOperateJob" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      lob="RE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      lob="RE"
      :job="currentRow"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :location="location"
      lob="AI"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- 业务状态变更记录弹窗 -->
    <business-status-log-dialog
      v-if="businessStatusDialog.visible"
      :visible.sync="businessStatusDialog.visible"
      :job-uuid="currentRow.uuid || ''"
    />
    <!-- SOP操作状态弹窗 -->
    <sop-state-dialog
      :hide-window="action!=='look'"
      :visible.sync="sopStateDialog.visible"
      :is-need-refresh.sync="sopStateDialog.isNeedRefresh"
      :job="currentRow"
      :default-is-expand="sopStateDialog.defaultIsExpand"
      :is-need-expand.sync="sopStateDialog.isNeedExpand"
      @handleClose="sopStateDialogClose"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 验证规则-保存业务节点弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      lob="AI"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!--关联业务信息-->
    <ai-trust-from-window
      v-if="trustFromWindow.visible"
      :visible.sync="trustFromWindow.visible"
      :trust-job="trustFromWindow.trustJob"
      :can-operate-job="canOperateJob"
    />
    <!--选择协作分公司-->
    <cooperation-branch-list
      v-if="cooperationBranchListDialog.visible"
      :visible.sync="cooperationBranchListDialog.visible"
      :job-uuid="cooperationBranchListDialog.jobUuid"
      :job="cooperationBranchListDialog.job"
      :order-center-branch="cooperationBranchListDialog.orderCenterBranch"
      @refresh="(cooperatebranch)=>{updateJobCooperate(cooperatebranch);this.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)}"
      @cancel="()=>cooperationBranchListDialog.visible=false"
    />
    <!-- 业务申请审批流 -->
    <job-apply-dialog
      v-if="jobApplyDialog.visible"
      :visible.sync="jobApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_SubmitJobChargeForApproval')"
      type="apply"
      :doc-id="currentRow.uuid"
      :document-config-id="documentConfigId"
      @close="jobApplyDialog.visible=false"
      @closeAndRefresh="applyCloseAndRefresh"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="AI"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="detail"
      @confirm="lookHandler"
    />
    <!-- 变更日志记录 弹窗 -->
    <data-update-log-dialog :hide-window="isEditing" :visible.sync="dataUpdateLogDialog.visible" :is-need-refresh.sync:="dataUpdateLogDialog.isNeedRefresh" :default-is-expand="dataUpdateLogDialog.defaultIsExpand" :job="job" :is-need-expand.sync="dataUpdateLogDialog.isNeedExpand" @handleClose="dataUpdateLogDialogClose" />
  </div>
</template>

<script>
import bookingWorkspaceJS from '@/views/cargo/v0/AirImport/components/booking/bookingWorkspace.js'
import { BookingWorkspaceContext } from '@/views/cargo/v0/AirImport/components/booking/bookingWorkspaceContext'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import tabBookingFcl from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue'
import tabBookingFCLUICustom from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCLUICustom.vue'
import tabBookingMaster from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue'
import tabBookingMasterUICustom from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMasterUICustom.vue'
import tabTradeDetail from '@/views/cargo/v0/AirImport/components/booking/tabs/tabTradeDetail'
import tabTradeCommission from '@/views/cargo/v0/AirImport/components/booking/tabs/tabTradeCommission'
import tabHbl from '@/views/cargo/v0/AirImport/components/booking/tabs/tabHBL'
import tabLocalService from '@/views/cargo/v0/AirImport/components/booking/tabs/tabLocalService'
import tabUsCustomsClearance from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearance'
import tabUsCustomsClearanceMaster from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMaster'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabFile from '@/components/Cargo/Job/booking/tabs/tabFile'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import chargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import URL from '@/api/urlTranslator'
import { getUserInfo } from '@/utils/auth'
import { catchErrorTip } from '@/utils/commonUtil'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import aiTrustFromWindow from '@/views/cargo/v0/AirImport/components/booking/aiTrustFromWindow'
import cooperationBranchList from '@/components/Cargo/Job/cooperationBranchList'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import JobApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import TabInsure from '@/components/Cargo/Job/booking/tabs/tabInsure'
import DataUpdateLogDialog from '@/components/Cargo/Job/dataUpdateLogDialog'
import { LOG_AI_AIR_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import { operateBranchIsOptional } from '@/utils/basicDataCache'
import BookingWorkspaceMixin from '@/mixin/BookingWorkspaceMixin'
import tabMawb from '@/views/cargo/v0/AirImport/components/booking/tabs/tabMAWB'
import { cache } from '@/utils/cacheManager'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { createDetailTabComponent } from './destinationDetailTabMixin'

const AiDetailTabBookingFcl = createDetailTabComponent(tabBookingFcl)
const AiDetailTabBookingFCLUICustom = createDetailTabComponent(tabBookingFCLUICustom)

export default {
  name: 'AiDetailWorkspace',
  components: {
    jobReturnReviewDialog,
    tabMawb,
    cargoLeftRightResize, cargoTemplateSelectorDialog, CargoButtonGroupSlider, tabBookingFcl: AiDetailTabBookingFcl, tabBookingFCLUICustom: AiDetailTabBookingFCLUICustom, tabBookingMaster, tabBookingMasterUICustom, tabTradeDetail, tabTradeCommission,
    tabHbl, tabLocalService, tabUsCustomsClearance, tabUsCustomsClearanceMaster, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabCustomsInfo, tabFile, tabSopState,
    tabFileHistory, BatchCheckingWindow, CheckingWindow, sopStateDialog, EstimateValidationDialog, addChargeDetailDialog,
    chargeSchemeBatchDialog, businessStatusLogDialog, checkingSaveJobWindow, aiTrustFromWindow, cooperationBranchList, CargoIm, JobApplyDialog, TabInsure, DataUpdateLogDialog
  },
  mixins: [BookingWorkspaceMixin],
  props: {
    parentContext: { type: Object, required: true },
    view: { type: String, default: '' }
  },
  data() {
    const currentUserInfo = getUserInfo()
    const leftGridColumnType = window.localStorage.getItem(`AI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`) || 'jobNo'
    return {
      imCacheKey: '',
      leftGridColumnType,
      optName: '', // 操作名称
      context: new BookingWorkspaceContext(this.parentContext),
      isCommittedAllowAddCost: false,
      action: '',
      isSwitchingJob: false, // 是否正在切换job（尾程商务/海外跟单）
      backEventFlag: false, // 返回事件标识
      editEventFlag: false, // 编辑事件标识
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: false,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: leftGridColumnType === 'jobNo' ? this.$t('SeaExport.BusinessNo') : 'MAWB',
          colId: leftGridColumnType,
          field: leftGridColumnType,
          width: 160,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return params.value
            }
          },
          tooltip: params => {
            return params.data.jobNo
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        getContextMenuItems: () => {
          const self = this
          const menu = [
            'copy',
            {
              name: self.$t('SeaExport.BusinessNo'),
              action: function() {
                const currentUserInfo = getUserInfo()
                self.leftGridColumnType = 'jobNo'
                window.localStorage.setItem(`AI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'jobNo')
              }
            }, {
              name: 'MAWB',
              action: function() {
                self.leftGridColumnType = 'mbl'
                const currentUserInfo = getUserInfo()
                window.localStorage.setItem(`AI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'mbl')
              }
            }
          ]
          return menu
        },
        onRowClicked: async event => {
          let data = event.data
          if (data.dataType && Number(data.dataType) !== 1 && Number(data.dataType) !== 2 && data.jobUuid) {
            for (const item of this.rowData) {
              if (item.uuid === data.jobUuid) {
                data = item
                break
              }
            }
          }
          this.action = data && Number(cache.config.get('JobDirectEditingStatus')) === 1 && data.jobState === 0 && !JobUtils.isBlockJob(data) && (await SecurityUtil.canEdit(new AirImportJob(data))) ? 'edit' : 'look'
          // 尾程商务/海外跟单详情页：参考海运订舱详情页的处理方式
          // 重新数据库中加载job，清空对象类型属性避免响应式更新导致的空白
          if (this.$route.path.startsWith('/DestinationBusiness')) {
            this.isGetNewJobInfoFromDb = true
            data.isCompleteRow = false
            data.version = 0
            for (const key in data) {
              if (typeof data[key] === 'object') {
                data[key] = ''
              }
            }
            // 更新当前页签标题为切换后的业务编号，避免新开页签
            this.$store.dispatch('tagsView/updateViewTitle', { view: this.$route, key: data.jobNo })
            await this.onRowClicked(event)
          } else {
            this.onRowClicked(event)
          }
        }
      },
      rowData: [],
      gridApi: null,
      JobUtils,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      activeTabName: '',
      isRefresh: false,
      stateInfo: {
        jobState: '',
        jobChangeState: '',
        jobNo: '',
        titleMblMid: '',
        customer: ''
      },
      chargeCommand: this.$t('SeaExport.AddCharges'),
      logCommand: this.$t('CargoMsg.Cargo_BusinessStatusChangeLog'),
      templateSelectorDialog: {
        visible: false,
        ctx: new AirImportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      addChargeDetailDialog: {
        visible: false,
        selectedScheme: [],
        selectedJobs: []
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        lob: 'AI',
        source: 'jobList',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      businessStatusDialog: {
        visible: false
      },
      sopTooltipOffset: 0,
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        defaultIsExpand: false,
        isNeedExpand: false
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => { }
      },
      copyJobNum: 0,
      saveJobNos: [], // 保存后的jobNo
      removedJobNos: [], // 被移除的jobNo
      btnGroupLook: null,
      btnGroupEdit: null,
      checkingSaveJobWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      trustFromWindow: {
        visible: false,
        trustJob: null // 关联业务job
      },
      cooperationBranchListDialog: { // 协作分公司
        visible: false,
        jobUuid: '',
        job: null,
        orderCenterBranch: false
      },
      SystemConstants: SystemConstants,
      jobApplyDialog: {
        visible: false
      },
      documentConfigId: Job_CHARGE.code,
      dataUpdateLogDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      commonInfo: {
        jobTitle: '',
        provisionPublished: false, // 计提已发布状态
        provisionLock: { etdLocked: false, feeLocked: false }
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      LOG_AI_AIR_BOOKING: LOG_AI_AIR_BOOKING,
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      sopTemplateConfig: {}, // SOP模板配置
      templateName: ''
    }
  },
  computed: {
    payableChargeLockedTooltip() {
      const details = []
      const person = ColumnUtils.getPayableChargeLockedPerson(this.job)
      const lockedAt = this.job.payableChargeLockedDate ? DateUtils.formatStandardDateTime(this.job.payableChargeLockedDate) : ''
      if (person) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockPerson')}：${person}`)
      }
      if (lockedAt) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockTime')}：${lockedAt}`)
      }
      return details.join('\n')
    },
    isNew() {
      return this.action === 'add' || this.action === 'copy' || this.action === 'addLcl'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    /** 与海出一致：仅首段为业务编号时插入主单号中段 */
    aiHeaderShowTitleMblMid() {
      return (Number(this.context.config.get('DetailTitleShowModel')) || 0) === 0
    },
    actionUrl() {
      return URL.booking.airImport.importCSVFile + '?branchId=' + this.$store.getters.currentOfficeId
    },
    printVisible() {
      return this.activeTabName !== 'tabTradeDetail' && this.activeTabName !== 'tabTradeCommission' && this.activeTabName !== 'tabAdvanceCharge' &&
        this.activeTabName !== 'tabSopState' && this.activeTabName !== 'tabFileHistory'
    },
    printReturnVisible() {
      return this.$checkPermission(['button_JobBooking_Retract']) && this.currentRow.jobState === SystemConstants.COMMITED
    },
    preSubmitVisible() {
      return this.$checkPermission(['button_JobBooking_PreSubmit']) && !this.printReturnVisible && this.currentRow.jobState === SystemConstants.OPERATING &&
        (this.currentRow.manageAuditStatus === 0 || this.currentRow.manageAuditStatus === 3)
    },
    submitVisible() {
      return this.$checkPermission(['button_JobBooking_Submit']) && !this.printReturnVisible && (this.currentRow.jobState === SystemConstants.OPERATING ||
        this.currentRow.jobState === SystemConstants.COMMITED || this.currentRow.jobState === SystemConstants.PRE_COMMIT) &&
        (this.currentRow.manageAuditStatus === 0 || this.currentRow.manageAuditStatus === 3)
    },
    managerSubmitVisible() {
      return this.$checkPermission(['button_JobBooking_ManagerSubmit']) && (this.currentRow.jobState === SystemConstants.OPERATING ||
        this.currentRow.jobState === SystemConstants.PRE_COMMIT)
    },
    submitAuditVisible() {
      return this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']) && (this.currentRow.jobState === SystemConstants.OPERATING ||
        this.currentRow.jobState === SystemConstants.PRE_COMMIT) && this.currentRow.manageAuditStatus === 1
    },
    printReturnOperateVisible() {
      return this.$checkPermission(['button_JobBooking_ReturnToOperater']) && this.currentRow.jobState === SystemConstants.PRE_COMMIT
    },
    shutoutButtonVisible() {
      return this.currentRow.shutOut ? this.$checkPermission(['button_AIBooking_cancelShutout']) : this.$checkPermission(['button_AIBooking_Shutout'])
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    useOrderCenterBranch() { // 是否开启接单分公司
      return this.context.config ? Number(this.context.config.get('orderCenterBranch')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus || -1
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    },
    isEditing() {
      return this.action !== 'look'
    },
    job() {
      return this.currentRow
    },
    location() {
      return LOG_AI_AIR_BOOKING.code
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllDetail
    },
    canOperateJob() {
      if (this.hqViewAllDetail) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (this.currentRow && this.currentRow.opOffice !== this.$store.getters.currentOfficeId && this.currentRow.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.currentRow.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      if (this.hierarchyViewDetail && this.currentRow) {
        return this.matchOwnerBranch(this.currentRow)
      }
      return true
    },
    showReturnReview() { // 是否显示退回按钮
      return this.currentRow.jobState === SystemConstants.STATE_OPERATING.code && !this.currentRow.masterFlag &&
        !this.currentRow.lclMasterUuid && (this.currentRow.preverifyState === SystemConstants.VERIFYING_AUDITED.code ||
        this.currentRow.preverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code)
    },
    canEditByPermission() {
      const menuType = this.$route.query.menuType
      const permissionCode = menuType === 'overseaTracking' ? 'button_OverseaTrackingEdit' : 'button_EndCommerceEdit'
      return this.$checkPermission([permissionCode])
    },
    trackingTemplateUuid() {
      return this.currentRow.trackingTemplateUuid
    }
  },
  watch: {

    leftGridColumnType(newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      console.log(newVal, oldVal)
      this.gridOptions.api.setAutoGroupColumnDef({
        headerName: newVal === 'jobNo' ? this.$t('SeaExport.BusinessNo') : 'MAWB',
        colId: newVal,
        field: newVal,
        width: 160,
        tooltip: (params) => {
          return newVal === 'jobNo' ? params.data.jobNo : params.data.mbl
        },
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true
        },
        suppressMenu: true
      })
    },
    action(newVal) {
      this.$nextTick(() => {
        this.$refs.cargoButtonGroupSlider.resizeHandler()
      })
    },
    backEventFlag(newVal) {
      if (newVal) {
        this.backEventFlag = false
        return catchErrorTip(() => {
          return this.goBack()
        })
      }
    },
    editEventFlag(newVal) {
      if (newVal) {
        this.editEventFlag = false
        return catchErrorTip(() => {
          return this.toEdit('edit')
        })
      }
    },
    '$store.getters.currentOfficeId': {
      handler() {
        if (!(this.$route.path.startsWith('/DestinationBusiness') || this.$route.name === 'AiBooking') || this.view !== 'detail') {
          return
        }
        if (this.hqViewAllList && !this.hqViewAllDetail) {
          if (this.$store.getters.currentOfficeId === 1) {
            this.$confirm(this.$t('queryJob.SwitchHQNotView'), this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
              confirmButtonText: this.$t('queryJob.JumpListPage'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.goBack()
            }).catch(() => {})
          }
        }
      }
    },
    trackingTemplateUuid: {
      immediate: true,
      async handler(newVal) {
        this.templateName = await SopUtil.getTemplateName(newVal)
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.SystemConstants = SystemConstants
    this.btnInfo = {
      operateNameCode: -1,
      isPrint: true,
      isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
      isPrintCommit: false, // 打印利润分析表是否提交业务
      printEvent: null,
      isPreCommit: false, // 预提交
      showMessage: true
    }
    this.chargeAccountIdObject = null
    getSopTemplateConfig({ lob: 'AI' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  mounted() {
    this.btnGroupLook = this.$el.getElementsByClassName('btn-group-look')[0]
    this.btnGroupEdit = this.$el.getElementsByClassName('btn-group-edit')[0]
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    ...bookingWorkspaceJS.methods,
    goBack() {
      this.visible = false
      this.$emit('back')
    }
  }
}
</script>

<style scoped lang="scss">
#app .details-view .grid-fill ::v-deep {
  width: 100%;
  min-width: 160px;
  height: 100%;
  flex-direction: row;
  .ag-theme-balham {
    .ag-header-container {
      width: 100% !important;
      .ag-header-row {
        width: 100% !important;
        .ag-header-cell {
          width: 100% !important;
          .ag-header-cell-resize {
            display: none;
          }
        }
      }
    }
    .ag-center-cols-container {
      width: 100% !important;
      .ag-row {
        .ag-cell {
          width: 100% !important;
        }
      }
    }
  }
}
.details-view {
  .btn-group-look.cannot-operate-job::v-deep,
  .tabs-container.cannot-operate-job::v-deep {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
  }
  .btn-group-look.cannot-operate-job::v-deep {
    .el-dropdown.can-operate {
      .el-button {
        &.el-button--primary {
          pointer-events: auto;
          background-color: #1F75D5;
          border-color: #1F75D5;
          &:focus, &:hover {
            background: #4c91dd;
            border-color: #4c91dd;
          }
        }
      }
    }
  }
}
</style>
